import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Hook para verificar se empresa possui dispositivos GPS ativos
 * Retorna true se houver pelo menos 1 dispositivo GPS configurado
 */
export function useHasGpsTracking(companyId?: string) {
  const { data: hasGps, isLoading } = useQuery({
    queryKey: ['has-gps-tracking', companyId],
    queryFn: async () => {
      if (!companyId) return false;
      
      const { data, error } = await supabase
        .rpc('get_gps_devices_with_vehicles', { 
          p_company_id: companyId 
        });
      
      if (error) {
        console.error('Error checking GPS devices:', error);
        return false;
      }
      
      return (data?.length || 0) > 0;
    },
    enabled: !!companyId,
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
  
  return {
    hasGps: hasGps || false,
    isLoading
  };
}
